import { usePacketBuilderContext } from 'lib/context/PacketBuilder/PacketBuilderContext';

import Icon from 'components/shared/Icon/Icon';
import Button from 'components/shared/Button/Button';

const EmptyPackets = () => {
  const { setOpenModal } = usePacketBuilderContext();
  return (
    <>
      <div className="flex w-full flex-col items-center pb-20">
        <Icon icon="illustration-empty-table" />
        <h1 className="text-base font-500 text-primary-900">No packets found</h1>
        <Button
          className="mt-4"
          textClassName="whitespace-nowrap"
          text="Add packet"
          icon="add-square-mono"
          size="xs"
          variant="link"
          onClick={() => {
            setOpenModal(true);
          }}
        />
      </div>
    </>
  );
};
export default EmptyPackets;
